import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import FJLocalStore from '../../../store/FJLocalStore';
import FJModalClose from '../FJModalClose/FJModalClose';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';

import styles from './FJDoNotShowAgainModal.module.less';
import FJHairstyleDemonstration from '../../FJAIHairstyleChanger/FJHairstyleChangerLeft/view/FJHairstyleDemonstration';
import FJAppConstant from '../../../constants/FJAppConstant';

const _renderContent = type => {
    switch (type) {
        case FJAppConstant.AI_HAIRSTYLE_CHANGER:
            return <FJHairstyleDemonstration />;
        default:
            null;
    }
};

function FJDoNotShowAgainModal({ onClose, id, type }) {
    const [isApply, setIsApply] = useState(false);

    const handleClick = useCallback(() => {
        isApply && localStorage.setItem(id, isApply);
        onClose && onClose(isApply);
    }, [id, isApply, onClose]);

    return (
        <div className={styles.do_not_show_box}>
            <FJModalClose onClick={() => handleClick()} />
            {_renderContent(type)}
            <div className={styles.do_not_show_footer}>
                <FJButton
                    text={FJLocalStore._('got-it')}
                    className={styles.btn_box}
                    type={FJButtonType.GRADIENT}
                    textClassName={styles.btn_text}
                    onClick={() => handleClick()}
                />

                <FJCheckBox
                    dataChange={setIsApply}
                    selected={isApply}
                    iconClassName={styles.checkbox}
                    textClassName={styles.apply_btn}
                    value={FJLocalStore._('don-t-show-again')}
                />
            </div>
        </div>
    );
}

FJDoNotShowAgainModal.propTypes = {
    onClose: PropTypes.func,
    id: PropTypes.string,
    type: PropTypes.string,
};

export default FJDoNotShowAgainModal;
